import ServiceTemplate from './ServiceTemplate';

const Urodynamics = () => {
  const data = {
    title: 'Urodynamics Testing',
    tagline: 'Get Answers. Diagnose the Root Cause.',
    description: 'Urodynamics testing evaluates how well the bladder, sphincters, and urethra store and release urine. This diagnostic testing helps identify the cause of urinary problems and guides treatment decisions.',
    causesTitle: 'When Urodynamics Testing Is Used',
    causes: [
      'Overactive bladder symptoms',
      'Urinary incontinence',
      'Difficulty emptying the bladder',
      'Recurrent urinary tract infections',
      'BPH symptom evaluation',
      'Unexplained urinary problems',
    ],
    symptoms: [],
    treatments: [
      'Comprehensive bladder function assessment',
      'Measurement of urinary flow and pressure',
      'Evaluation by our specialty Urodynamics RN',
      'Clear explanation of results and treatment options',
    ],
    faqs: [
      { q: 'Is urodynamics testing uncomfortable?', a: 'Most patients experience only mild discomfort. Our specialty RN, Dawn Matrigali, ensures you are comfortable throughout the procedure.' },
      { q: 'How should I prepare for the test?', a: 'You may be asked to arrive with a full bladder. Our staff will provide specific instructions before your appointment.' },
      { q: 'How long does the testing take?', a: 'The complete evaluation typically takes 30-60 minutes. Results are usually available immediately for discussion.' },
    ],
    cta: 'Schedule testing today.',
    seoTitle: 'Urodynamics Testing Melbourne FL',
    seoDescription: 'Advanced urodynamics testing in Melbourne, FL. Evaluate bladder function, urinary flow, and related conditions with our specialized RN. Call (321) 500-4545.',
    seoKeywords: 'urodynamics testing Melbourne FL, bladder function test, urinary flow test, urodynamic evaluation, bladder testing',
    seoCanonical: '/services/urodynamics',
  };

  return <ServiceTemplate {...data} />;
};

export default Urodynamics;
